import { render, staticRenderFns } from "./Component.CardForList.vue?vue&type=template&id=3e10a07f&scoped=true&"
import script from "./Component.CardForList.vue?vue&type=script&lang=js&"
export * from "./Component.CardForList.vue?vue&type=script&lang=js&"
import style0 from "./Component.CardForList.vue?vue&type=style&index=0&id=3e10a07f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10a07f",
  null
  
)

export default component.exports